$(function() {
  $('nav.header__inline-menu>ul.list-menu.list-menu--inline>li').on('mouseenter mouseleave', function(event) {
    var firstChildTag = $(this).children().first().prop('tagName');

    if (firstChildTag === 'HEADER-MENU') {
      var detailsElement = $(this).find('details').eq(0);
      if (event.type === 'mouseenter') {
        detailsElement.attr('open', true);
      } else {
        detailsElement.removeAttr('open');
      }
    }
  });
});